export const menuSections = {
	comoFunciona: {
		id: 'como-funciona',
		name: 'Como funciona',
	},
	convites: {
		id: 'convites',
		name: 'Convites',
	},
	sobreNos: {
		id: 'sobre-nos',
		name: 'Sobre nós',
	},
}
